export enum ParameterTypeEnum {
    REFERENCE_DATE = "REFERENCE_DATE",
    START_DATE = "START_DATE",
    END_DATE = "END_DATE",
    QUARTER_AND_YEAR = "QUARTER_AND_YEAR",
    DATE_RANGE = "DATE_RANGE",
    YEAR = "YEAR",
}
